import { createPostRequest } from '_helpers';

export async function getFileTracking( values ) {
    return createPostRequest("filetracking_getData", values)
        .then(res => res.data)
        .then(({ success, data, errorMsg, redirect = false }) => {
            return { response: success, data, errorMsg, redirect };
        })
}